import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';


export default function PrintAccounts({accounts}) {
  const { t } = useTranslation();


  useEffect(() => { // Handle print
    const beforePrint = () => document.getElementById('print').style.display = 'block';
    const afterPrint = () => document.getElementById('print').style.display = 'none';

    window.addEventListener('beforeprint', beforePrint);
    window.addEventListener('afterprint', afterPrint);

    return () => {
      window.removeEventListener('beforeprint', beforePrint);
      window.removeEventListener('afterprint', afterPrint);
    };
  }, []);


  return (
    <div id="print">
      <table id="print__header">
        <thead>
          <tr>
            <th id="print__logo">
              <img src="/assets/images/logo.png" alt="Logo"/>
              <p style={{display: 'none' /* used as brand name in excel file */}}>SoftThinks</p>
            </th>
            <th style={{fontSize: '24px', fontWeight: '600'}}>{t('global.dashboard')}</th>
          </tr>
          {/* Spacing */}<tr/><tr/>
        </thead>

        <tbody style={{fontWeight: '600'}}>
          <tr>
            <td>{t('admin.accounts.print.header', {s: accounts.length > 1 ? 's' : ''})}</td>
            <td>{accounts.length}</td>
          </tr>
          {/* Spacing */}<tr/><tr/><tr/>
        </tbody>
      </table>

      <table id="print__content">
        <thead>
          <tr>
            <th style={{textAlign: 'center', width: '5%'}}>{t('admin.accounts.print.content.active')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '25%'}}>{t('admin.accounts.print.content.username')}</th>
            <th style={{textAlign: 'right', width: '25%'}}>{t('admin.accounts.print.content.email')}</th>
            <th className="separation"/>

            <th style={{textAlign: 'left', width: '20%'}}>{t('admin.accounts.print.content.role')}</th>
            <th style={{textAlign: 'right', width: '25%'}}>{t('admin.accounts.print.content.group')}</th>
          </tr>
        </thead>

        <tbody>
          {accounts.map(acc => (
            <tr style={{margin: '10px 0'}} key={acc.id}>
              <td style={{textAlign: 'center'}}>{t(acc.isActivated ? 'global.yes' : 'global.no')}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{acc.email}</td>
              <td style={{textAlign: 'right'}}>{acc.contactEmail}</td>
              <td className="separation"/>

              <td style={{textAlign: 'left'}}>{acc.role}</td>
              <td style={{textAlign: 'right'}}>{acc.group}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}